function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "28",
  height: "17",
  viewBox: "0 0 28 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  cx: "50%",
  cy: "50%",
  fx: "50%",
  fy: "50%",
  r: "50.42%",
  gradientTransform: "matrix(0 .99167 -1.01649 0 1.008 .004)",
  id: "radialGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFEEE0",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F48120",
  offset: "100%"
}))), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.65 16.093V.907a.57.57 0 00-.583-.557H.933A.57.57 0 00.35.907v15.186c0 .305.26.557.583.557h26.134a.57.57 0 00.583-.557z",
  stroke: "#F58220",
  strokeWidth: ".7",
  fill: "#F9F9F9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 17h20.035c.533 0 .965-.391.965-.873V10c-1.923 1.102-9.172 4.901-21 7",
  fill: "#F58220"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.429 9.246c-.162.15-.37.216-.701.216H6.59V7.67h.138c.331 0 .53.061.7.22a.923.923 0 01.284.673c0 .26-.106.521-.283.683M6.83 7.212h-.752V9.92h.749c.397 0 .684-.097.936-.312.299-.257.477-.642.477-1.04 0-.8-.58-1.356-1.41-1.356M8.476 9.92h.518V7.211h-.518zM10.24 8.25c-.308-.117-.398-.194-.398-.34 0-.17.16-.3.382-.3.153 0 .28.064.413.218l.268-.36c-.22-.2-.484-.302-.772-.302-.464 0-.819.333-.819.776 0 .374.166.565.646.743.2.073.303.122.354.155.103.07.154.166.154.28 0 .22-.17.382-.398.382-.244 0-.44-.126-.559-.362l-.33.33c.235.357.52.516.91.516.53 0 .904-.366.904-.89 0-.43-.172-.626-.755-.846M11.157 8.567c0 .797.606 1.414 1.386 1.414.22 0 .41-.044.642-.158V9.2c-.206.212-.386.296-.619.296-.515 0-.882-.385-.882-.934 0-.52.378-.93.859-.93.243 0 .429.09.642.305v-.622a1.275 1.275 0 00-.63-.165c-.776 0-1.398.63-1.398 1.416M17.334 9.031l-.701-1.82h-.559l1.115 2.779h.275l1.134-2.779h-.555zM18.83 9.92h1.453v-.459h-.94V8.73h.905V8.27h-.906v-.6h.941v-.46h-1.452zM21.283 8.458h-.15v-.82h.158c.32 0 .493.138.493.402 0 .272-.174.418-.501.418m1.027-.447c0-.508-.338-.8-.929-.8h-.76v2.71h.513V8.83h.067l.708 1.09h.63l-.827-1.142c.386-.081.598-.353.598-.768",
  fill: "#001722"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.575 7.443h-.01v-.06h.01c.028 0 .042.01.042.029 0 .02-.015.03-.042.03m.097-.03c0-.047-.031-.072-.087-.072h-.075v.232h.055v-.09l.064.09h.07l-.078-.096c.033-.009.05-.032.05-.065",
  fill: "#231F20"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.595 7.619a.163.163 0 01-.162-.166c0-.092.072-.166.162-.166.088 0 .16.075.16.166 0 .091-.072.166-.16.166m0-.369a.201.201 0 00-.201.203c0 .112.09.202.201.202a.202.202 0 000-.405",
  fill: "#231F20"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.379 1.553c0 .817.6 1.428 1.4 1.428a1.39 1.39 0 001.396-1.412C10.175.78 9.563.16 8.78.16c-.773 0-1.4.623-1.4 1.392",
  fill: "url(#radialGradient-1)",
  transform: "translate(6 7)"
}))));